import ApiService from "@/service/ApiService";

export default function useRegister() {
  const Register = async (data) => {
    return await ApiService.post("scx/register_student", data);
  };

  const GetCommunitys = async () => {
    return await ApiService.get("scx/get_communitys");
  };

  const UpdateUser = async (data) => {
    return await ApiService.put("scx/edit_user/" + data.id_line, data);
  };

  const History = async () => {
    return await ApiService.get("scx/register_student_history");
  };

  return {
    Register,
    UpdateUser,
    GetCommunitys,
    History
  };
}
